import Lazyload from './lazyload';
export default Lazyload;
export { Lazyload };